import PropTypes from "prop-types";
import React from "react";

import PoliciesTableFilter from "../../policies/containers/PoliciesTableFilter";
import { EntityShape, GroupShape, UserShape } from "../../policies/proptypes";
import GroupsListItem from "./GroupsListItem";

const GroupsList = ({
  entities,
  currentGroup,
  currentUser,
  sortBy,
  setSortState,
  onItemSelect
}) => {
  const list = entities.map(entity => (
    <GroupsListItem
      key={entity.$uri}
      entity={entity}
      selected={
        (currentGroup && entity.$uri === currentGroup.$uri) ||
        (currentUser && entity.$uri === currentUser.$uri)
      }
      onItemSelect={onItemSelect}
    />
  ));

  return (
    <div className="l-groups__column" style={{ gridArea: "entities" }}>
      <div className="l-groups__column-header">
        <span className="p-muted-heading u-no-margin--bottom">
          Groups / Users
        </span>
      </div>
      <div className="l-groups__column-panel">
        <PoliciesTableFilter sortBy={sortBy} setSortState={setSortState} />
        <ul
          style={{ marginTop: ".5rem" }}
          className="p-list u-no-margin--bottom"
        >
          {list}
        </ul>
      </div>
    </div>
  );
};

GroupsList.defaultProps = {
  currentGroup: undefined,
  currentUser: undefined,
  sortBy: undefined
};

GroupsList.propTypes = {
  entities: PropTypes.arrayOf(EntityShape).isRequired,
  currentGroup: GroupShape,
  currentUser: UserShape,
  setSortState: PropTypes.func.isRequired,
  sortBy: PropTypes.string,
  onItemSelect: PropTypes.func.isRequired
};

export default GroupsList;
